"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSubscribePopup = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _constants = require("../constants");
var _utils = require("../utils");
const useSubscribePopup = ({
  open,
  onOpen,
  footer,
  popup
}) => {
  (0, _react.useEffect)(() => {
    // Return early if newsletter or popup is not enabled
    if (!footer?.enabled || !popup?.enabled) {
      return;
    }
    const popupDelay = popup.delayInSeconds;
    // Return early if time is not set
    if (popupDelay < 1) {
      return;
    }

    // Return early if person is already subscribed or the popup was opened before
    if ((0, _utils.isCookieSet)(_constants.newsletterSubscribeCookieKey, _constants.newsletterSubscribeCookieValue) || !open && (0, _utils.isCookieSet)(_constants.newsletterPopupCookieKey, _constants.newsletterPopupCookieValue)) {
      return;
    }

    // Set up delayed popup and set cookie that will expire in number of days set in Sitecore
    const timer = setTimeout(() => {
      _jsCookie.default.set(_constants.newsletterPopupCookieKey, _constants.newsletterPopupCookieValue, {
        expires: popup.displayFrequencyInDays
      });
      onOpen();
    }, popupDelay * 1000);

    // If dialog is open we do not need delayed opening
    if (open) {
      clearTimeout(timer);
    }

    // eslint-disable-next-line consistent-return -- cleanup function
    return () => clearTimeout(timer);
  }, [open, footer, popup, onOpen]);
};
exports.useSubscribePopup = useSubscribePopup;
